import JobPostingResponses from "../components/Recruiting/JobPostingResponses.vue";
import {PERM} from "../utilites/permissions";

const jobPostingResponses = [
  {
    path: '/responses/:id(\\d+)?',
    name: 'JobPostingResponses',
    component: JobPostingResponses,
    meta: {
      requiresAuth: true,
      permissions: [
        PERM.RECRUIT_JOB_POSTING,
      ]
    }
  },
];

export default jobPostingResponses;



// WEBPACK FOOTER //
// ./src/router/jobPostingResponses.js